import React from "react";
import { Typography, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { colours } from "../../utilities/styles";

const Container = styled.div`
  text-align: "center";
  margin: "20px 0";
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PremiumSignup = () => {
  const mailto =
    "mailto:anna@yomento.com?subject=Leadership Dashboard - Premium Account&body=Hi there, %0A%0AI would like to know more about the data and insights that are provided through the Premium account. %0A%0APlease get back to me to book a call! %0A%0ABest regards,";
  return (
    <Container>
      <Typography variant="body1">Want to see more?</Typography>
      <Typography style={{ fontWeight: "bold", paddingBottom: "20px" }} variant="body1">
        Get a Premium account!
      </Typography>
      <Link
        to="#"
        onClick={(e) => {
          window.location = mailto;
          e.preventDefault();
        }}
      >
        <Button color="primary" variant="contained">
          CONTACT US
        </Button>
      </Link>
    </Container>
  );
};

export default PremiumSignup;
